module.exports = __webpack_public_path__ + "resources/images/bon-02f20ffd8af68d5cd5c83ca7c0956b7a-cache.jpg";